import React from "react";
import { Table } from "react-bootstrap";

import { BessBalancoEnergetico, BessFaixaEnergia } from "../../types";

interface BessEnergyBalanceProps {
  balanco: BessBalancoEnergetico;
}

const formatKwh = (value: number): string =>
  Math.round(value).toLocaleString("pt-BR");

const formatKwhDelta = (value: number): string => {
  const rounded = Math.round(value);
  const formatted = Math.abs(rounded).toLocaleString("pt-BR");
  if (rounded > 0) return `+${formatted}`;
  if (rounded < 0) return `-${formatted}`;
  return formatted;
};

interface BalanceRowsProps {
  labelOriginal: string;
  labelAjustado: string;
  labelDiferenca: string;
  original: BessFaixaEnergia;
  ajustado: BessFaixaEnergia;
}

const BalanceRows: React.FC<BalanceRowsProps> = ({
  labelOriginal,
  labelAjustado,
  labelDiferenca,
  original,
  ajustado,
}) => (
  <tbody>
    <tr>
      <td>{labelOriginal}</td>
      <td>{formatKwh(original.foraPontaKwh)}</td>
      <td>{formatKwh(original.pontaKwh)}</td>
      <td>{formatKwh(original.totalKwh)}</td>
    </tr>
    <tr>
      <td>{labelAjustado}</td>
      <td>{formatKwh(ajustado.foraPontaKwh)}</td>
      <td>{formatKwh(ajustado.pontaKwh)}</td>
      <td>{formatKwh(ajustado.totalKwh)}</td>
    </tr>
    <tr style={{ color: "#7e7e82" }}>
      <td>{labelDiferenca}</td>
      <td>{formatKwhDelta(ajustado.foraPontaKwh - original.foraPontaKwh)}</td>
      <td>{formatKwhDelta(ajustado.pontaKwh - original.pontaKwh)}</td>
      <td>{formatKwhDelta(ajustado.totalKwh - original.totalKwh)}</td>
    </tr>
  </tbody>
);

export const BessEnergyBalance: React.FC<BessEnergyBalanceProps> = ({
  balanco,
}) => (
  <div>
    <h4 className="bess-section-title">Balanço energético do mês</h4>
    <div style={{ overflow: "auto" }}>
      <Table>
        <thead>
          <tr>
            <th />
            <th>Fora ponta (kWh)</th>
            <th>Ponta (kWh)</th>
            <th>Total (kWh)</th>
          </tr>
        </thead>
        <BalanceRows
          labelOriginal="Consumo original"
          labelAjustado="Consumo ajustado (com bateria)"
          labelDiferenca="Diferença de consumo"
          original={balanco.consumo.original}
          ajustado={balanco.consumo.ajustado}
        />
        <BalanceRows
          labelOriginal="Geração original"
          labelAjustado="Geração ajustada (com bateria)"
          labelDiferenca="Diferença de geração"
          original={balanco.geracao.original}
          ajustado={balanco.geracao.ajustado}
        />
      </Table>
    </div>
  </div>
);
